// extracted by mini-css-extract-plugin
export var closeButton = "_id-2";
export var closeButtonIcon = "_id-3";
export var lightboxContent = "_id-1";
export var lightboxOverlay = "_id-0";